import angular from 'angular';

class adminCreationConfirmationModalCtrl {
  /* @ngInject */
  constructor($translate) {
    this.$translate = $translate;
  }
  $onInit() {}

  confirm() {
    this.modalInstance.close();
  }
  getTranslatedRole(role) {
    return this.$translate.instant('kiss_user.profil.' + role.toLowerCase());
  }

  translateMessage(value) {
    return this.$translate.instant(
      'principal.config_portal.admin_creation.profil_group',
      {
        profile: this.getTranslatedRole(value.role),
        group: value.legalEntityGroup.name
      },
      '',
      '',
      'sce'
    );
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }
}

angular.module('app.principal').component('adminCreationConfirmationModal', {
  templateUrl: require('./admin-creation-confirmation-modal.html'),
  controller: adminCreationConfirmationModalCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
